export const SET_ANSWER = 'SET_ANSWER'
export const CLEAR_ANSWERS = 'CLEAR_ANSWERS'
export const SET_PARTICIPANT = 'SET_PARTICIPANT'
export const CLEAR_PARTICIPANT = 'CLEAR_PARTICIPANT'
